export const POST = "POST";
export const GET = "GET";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE"; 
export const PUT = "PUT"; 
